export const tabButtonClass = {
  base: 'inline-flex items-center justify-center px-[12px] py-[10px] gap-[10px]',
  active: 'border-b-2 border-[var(--primaryColor500)]',
  inactive: 'bg-none border-none cursor-pointer',
};
export const tabSpanClass = {
  base: "inline-block text-center font-['Inter'] min-w-[115px] min-h-[20px]",
  active: 'font-bold text-[14px] leading-[20px] tracking-[0px] text-[var(--primaryColor500)]',
  inactive: 'font-normal text-[14px] leading-[20px] tracking-[0px] text-[rgba(0,0,0,0.56)]',
};

export const tabList = [
  { label: 'Thông tin cơ bản', activeKey: 'TTCB' },
  { label: 'Chi tiết công nợ', activeKey: 'CTCN' },
  { label: 'Lịch sử giao dịch', activeKey: 'LSGD' },
];

export const tabListProduct = [
  { label: 'Chi tiết sản phẩm', activeKey: 'CTSP' },
  { label: 'Thẻ kho', activeKey: 'TK' },
];
